
import * as s from './styles';
import FadeInUp from '../../atoms/fade-in-up';
import type { ILogosProps } from '@klv/organisms/logos/types';

const Logos = ({ className, ...props }: ILogosProps & { className?: string; }) => {
  return (
    <FadeInUp className={className}>
      <s.StyledLogos
        {...props}
        buttonVariants={['ghost']}
      />
    </FadeInUp>
  );
};

export default Logos;
